import { render, staticRenderFns } from "./BookingFailure.vue?vue&type=template&id=c50073c2"
import script from "./BookingFailure.vue?vue&type=script&lang=js"
export * from "./BookingFailure.vue?vue&type=script&lang=js"
import style0 from "./BookingFailure.vue?vue&type=style&index=0&id=c50073c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports